import Demo from "./demo";
import Emg from "./emergency";
import Payment from "./payment";
//import Bigdata from "./bigdata";

const plugins = {
   Demo,
   Emg,
   Payment,
 //  Bigdata,
};

export default plugins;
